var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { Form } from "../Form";
import { Flex } from "../Flex";
import styled from "styled-components";
import { INPUT_GROUP, COURSE_FILTERS } from "../../classConstants";
import { CourseFilterDropdown } from "./CourseFilterDropdown";
import { getClassName } from "../../helpers";
import { CourseSearchFilter } from "./CourseSearchFilter";
var courseFilterFactory = function () {
    var CourseFiltersNoStyle = function (_a) {
        var onUpdate = _a.onUpdate, _b = _a.className, className = _b === void 0 ? "" : _b, filterOptions = _a.filterOptions, filterPrefix = _a.filterPrefix, showSearchFilter = _a.showSearchFilter;
        var renderFilters = function () {
            return filterOptions.map(function (_a) {
                var name = _a.name, options = _a.options;
                return React.createElement(CourseFilterDropdown, { key: name, onUpdate: onUpdate, filterPrefix: filterPrefix, prop: name, options: options });
            });
        };
        return React.createElement(React.Fragment, null,
            React.createElement(Form, { className: getClassName(className, COURSE_FILTERS) },
                React.createElement(Flex, null,
                    React.createElement(React.Fragment, null, showSearchFilter ? React.createElement(CourseSearchFilter, { filterPrefix: filterPrefix, onUpdate: onUpdate }) : null),
                    renderFilters())));
    };
    return styled(CourseFiltersNoStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        .", " {\n            flex: 1;\n            padding: 15px;\n            &:first-child { padding-left: 0; }\n            &:last-child { padding-right: 0; }\n\n            ", "\n        }\n    "], ["\n        .", " {\n            flex: 1;\n            padding: 15px;\n            &:first-child { padding-left: 0; }\n            &:last-child { padding-right: 0; }\n\n            ",
        "\n        }\n    "])), INPUT_GROUP, function (props) { return props.stacked && "\n                min-width: 100%;\n                padding: 0;\n            "; });
};
export var CourseFilters = courseFilterFactory();
var templateObject_1;
